@if (isExpanded()) {
  @if (menuTab().collapsible) {
    <button
      type="button"
      (click)="toggleExpansion()"
      class="text-standard-text-secondary hover:bg-standard-hover-main flex h-10 w-full cursor-pointer items-center rounded-xl px-2 text-left text-sm transition-colors focus:outline-hidden">
      <span>{{ menuTab().heading }}</span>
      <span class="material-symbols-rounded ml-auto text-xl">
        {{ menuTab().expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
      </span>
    </button>
  } @else {
    <span class="text-l text-standard-text-primary block px-2">{{
      menuTab().heading
    }}</span>
  }
} @else {
  <hr
    class="border-standard-divider via-standard-text-secondary bg-standard-surface my-1 bg-linear-to-r from-transparent to-transparent" />
}
@if (!menuTab().collapsible || !isExpanded() || menuTab().expanded) {
  <ul class="mt-1 flex flex-col gap-1">
    @for (item of menuTab().items; track $index) {
      <li>
        <aw-sidebar-item
          [item]="item"
          [isExpanded]="isExpanded()"></aw-sidebar-item>
      </li>
    }
    @for (menu of menuTab().menus; track $index) {
      <li>
        <aw-sidebar-menu
          [menu]="menu"
          [sideBarExpanded]="isExpanded()"></aw-sidebar-menu>
      </li>
    }
  </ul>
}
